<template>
<div class="row fl-row-tabela animated fadeIn fast">
	<div class="col-md-12">
		<div class="table-responsive card card-table">
			<div>
				<table class="table fl-table table-borderless table-hover">
					<thead>
						<tr>
							<th>Data</th>
							<th class="text-center">Acionamento</th>
							<th class="text-center">Decolagem</th>
							<th class="text-center">Pouso</th>
							<th class="text-center">Corte</th>
							<th class="text-center">Decimal <br/><small>Decolagem ao Pouso</small></th>
							<th class="text-center">Decimal <br/><small>Acionamento ao Corte</small></th>
							<th style="width:8%" class="text-center">Editar</th>
							<th style="width:8%" class="text-center">Excluir</th>
							<th style="width:8%" class="text-center">Posições</th>
						</tr>
					</thead>
					<tbody>
						<tr  v-for="(item, index) in _trechos" :key="index">
							<td style="width:10%">
								<div v-if="!exibirUTC">{{item._data}} </div>
								<div v-if="exibirUTC">{{item._dataUTC}}</div>
							</td>
							<td class="text-center" style="width:8%">
								<div v-if="!exibirUTC">{{item.acionamento}}</div>
								<div v-if="exibirUTC">{{item._acionamentoUTC}}</div>
							</td>
							<td class="text-center" style="width:8%">
								<div v-if="!exibirUTC">{{item.decolagem}}</div>
								<div v-if="exibirUTC">{{item._decolagemUTC}}</div>
							</td>
							<td class="text-center" style="width:8%">
								<div v-if="!exibirUTC">{{item.pouso}}</div>
								<div v-if="exibirUTC">{{item._pousoUTC}}</div>
							</td>
							<td class="text-center" style="width:8%">
								<div v-if="!exibirUTC">{{item.corte}}</div>
								<div v-if="exibirUTC">{{item._corteUTC}}</div>
							</td>
							<td class="text-center" style="width:10%">
								{{item.decolagemPouso}}
							</td>
							<td class="text-center" style="width:10%">
								{{item.acionamentoCorte}}
							</td>
							<td class="text-center">
								<a href="#" @click.prevent="$emit('click-editar', item)"
											style="color: blue">
									<fa-icon icon="pen-alt"  style="font-size: 0.9rem" />
								</a>
							</td>
							<td class="text-center">
								<a href="#" @click.prevent="$emit('clickExcluir', item)"
											style="color: red">
									<fa-icon :icon="['far', 'trash-alt']"  style="font-size: 0.9rem" />
								</a>
							</td>
							<td class="text-center">
								<a href="#" @click.prevent="$emit('clickPosicoes', item)">
									<fa-icon icon="map-marker-alt" style="font-size: 0.9rem" />
								</a>

							</td>
						</tr>

					</tbody>
				</table>
			</div>
		</div>
	</div>
</div>
</template>

<script>
import _ from 'lodash'
export default {

	props: ['trechos', 'data', 'exibirUTC'],

	computed: {
		_trechos() {
			if (this.data == "") {
				return this.trechos;
			} else {
				return _.filter(this.trechos, o => {
					return o._data == this.data;
				});
			}
		}
	},
}
</script>



// WEBPACK FOOTER //
// src/views/equipamento/detalhe/trecho/tabela-trecho.vue